import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const NotFound = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <div className="h-[88vh] p-2 flex text-center flex-col items-center justify-center gap-3">
      <h1 className="text-2xl md:text-3xl font-semibold">
        404 - Page Not Found
      </h1>
      <p className="md:text-lg">
        Oops! The page you-re looking for doesn't exist.
      </p>
      <Link to={isAuthenticated ? "/home" : "/"}>
        <button className="bg-theme-color font-medium hover:bg-medium-theme-color transition-colors duration-300 hover:text-white py-2 px-4 rounded-full">
          Go to Home
        </button>
      </Link>
    </div>
  );
};

export default NotFound;
